var text_field_default = {
  "root": "q5AeI",
  "text": "TyBU7",
  "input": "rzKoP",
  "small": "CPBX2",
  "medium": "HZTgF",
  "large": "-wD6M",
  "webview": "G1TSv",
  "endAdornment": "_8upbE",
  "shown": "y9Svl",
  "value": "kGoqi",
  "spinner": "QVWk-",
  "spin": "_7XJcZ"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
